const initialState = {
  count: 0,
  data: undefined,
  errorMessage: null,
  isLoading: false,
  isFulfilled: false,
  isRejected: false,
};

export const GetListDocumentationData = (state = initialState, action) => {
  switch (action.type) {
    case "GET_LIST_DOCUMENTATION_PENDING":
      return {
        ...state,
        isLoading: true,
        isRejected: false,
        isFulfilled: false,
      };
    case "GET_LIST_DOCUMENTATION_REJECTED":
      return {
        ...state,
        isLoading: false,
        isRejected: true,
        errorMessage: action.payload.response.data ?? null,
      };
    case "GET_LIST_DOCUMENTATION_FULFILLED":
      return {
        ...state,
        isLoading: false,
        isFulfilled: true,
        count: action.payload.response.data?.count ?? 0,
        data: action.payload.response.data?.results ?? null,
      };
    default:
      return state;
  }
};
